import { type ComponentProps } from "react"
import { AlertDialogPortal as AlertDialogPortalBase } from "./base/AlertDialogBase"

export type AlertDialogPortalProps = ComponentProps<
  typeof AlertDialogPortalBase
>

function AlertDialogPortal(props: AlertDialogPortalProps) {
  return <AlertDialogPortalBase {...props} />
}

export default AlertDialogPortal
